import {
    REQUEST_USERS_PENDING,
    REQUEST_USERS_SUCCESS,
    REQUEST_USERS_FAILED,
    REQUEST_TOP_USERS_PENDING,
    REQUEST_TOP_USERS_SUCCESS,
    REQUEST_TOP_USERS_FAILED,
    REQUEST_FOLLOWERS_PENDING,
    REQUEST_FOLLOWERS_SUCCESS,
    REQUEST_FOLLOWERS_FAILED,
    REQUEST_CUSTOMIZE_PENDING,
    REQUEST_CUSTOMIZE_SUCCESS,
    REQUEST_CUSTOMIZE_FAILED,
    COLOR_BUTTON,
    REQUEST_COLOR_BUTTON_PENDING,
    REQUEST_COLOR_BUTTON_SUCCESS,
    REQUEST_COLOR_BUTTON_FAILED,
    COLOR_BACKGROUND,
    REQUEST_COLOR_BACKGROUND_PENDING,
    REQUEST_COLOR_BACKGROUND_SUCCESS,
    REQUEST_COLOR_BACKGROUND_FAILED,
    FONT_SIZE,
    REQUEST_FONT_SIZE_PENDING,
    REQUEST_FONT_SIZE_SUCCESS,
    REQUEST_FONT_SIZE_FAILED,
    REQUEST_ROOM_PENDING,
    REQUEST_ROOM_SUCCESS,
    REQUEST_ROOM_FAILED,
    SECOND_USER,
    REQUEST_SECOND_USER_PENDING,
    REQUEST_SECOND_USER_SUCCESS,
    REQUEST_SECOND_USER_FAILED,
    ROOM_MESSAGES,
    REQUEST_ROOM_MESSAGES_PENDING,
    REQUEST_ROOM_MESSAGES_SUCCESS,
    REQUEST_ROOM_MESSAGES_FAILED,
    SECTION_TITLE,
    REQUEST_USER_PENDING,
    REQUEST_USER_SUCCESS,
    REQUEST_USER_FAILED,
    REQUEST_HOME_POSTS_PENDING,
    REQUEST_HOME_POSTS_SUCCESS,
    REQUEST_HOME_POSTS_FAILED,
    DIALOG_TWEET_SHOW,
    DIALOG_CUSTOMIZE_SHOW,
    BACK_BUTTON_SHOW,
    ROOMS_SECOND_USER_ID_ARRAY,
    EDIT_PROFILE_FIRSTNAME,
    EDIT_PROFILE_LASTNAME,
    EDIT_PROFILE_USERNAME,
    EDIT_PROFILE_DESCRIPTION,
    EDIT_PROFILE_BIRTHDAY
} from "../constants/constants";
import axios from "axios";

export const editFirstName = (text) => {
    return {
        type:EDIT_PROFILE_FIRSTNAME,
        payload:text
    }
}

export const editLastName = (text) => {
    return {
        type:EDIT_PROFILE_LASTNAME,
        payload:text
    }
}

export const editUserName = (text) => {
    return {
        type:EDIT_PROFILE_USERNAME,
        payload:text
    }
}

export const editDescription = (text) => {
    return {
        type:EDIT_PROFILE_DESCRIPTION,
        payload:text
    }
}

export const editBirthday = (text) => {
    return {
        type:EDIT_PROFILE_BIRTHDAY,
        payload:text
    }
}

export const requestUsers = (text) => (dispatch) => {
    dispatch({type: REQUEST_USERS_PENDING});
    fetch(`/users/search?q=${text}`)
    .then(res => res.json())
    .then(data => {
        dispatch({type: REQUEST_USERS_SUCCESS, payload: data})
    })
    .catch(error => dispatch({type: REQUEST_USERS_FAILED, payload: error.message}))
}

export const requestTopUsers = (text) => (dispatch) => {
    dispatch({type: REQUEST_TOP_USERS_PENDING});
    fetch(`/users/top/${text}`)
    .then(res => res.json())
    .then(data => {
        dispatch({type: REQUEST_TOP_USERS_SUCCESS, payload: data})
    })
    .catch(error => dispatch({type: REQUEST_TOP_USERS_FAILED, payload: error.message}))
}

export const getNumberFollowers = (text) => (dispatch) => {
    dispatch({type: REQUEST_FOLLOWERS_PENDING});
    fetch(`/follow/number?q=${text}`)
    .then(res => res.json())
    .then(data => {
        dispatch({type: REQUEST_FOLLOWERS_SUCCESS, payload: data})
    })
    .catch(error => dispatch({type: REQUEST_FOLLOWERS_FAILED, payload: error.message}))
}

export const getCustomize = (id) => (dispatch) => {
    dispatch({type: REQUEST_CUSTOMIZE_PENDING});
    fetch(`/customize?q=${id}`)
    .then(res => res.json())
    .then(data => {
        dispatch({type: REQUEST_CUSTOMIZE_SUCCESS, payload: data[0]})
    })
    .catch(error => dispatch({type: REQUEST_CUSTOMIZE_FAILED, payload: error.message}))
}

export const handleFontSizeChange = (size,id) => async(dispatch) => {
    dispatch({
        type:FONT_SIZE,
        payload:size
    });
    dispatch({type: REQUEST_FONT_SIZE_PENDING});
    try{
        const result = await axios.put(`/customize/fontsize?q=${id}`,{
            font_size:size
        });
        dispatch({type: REQUEST_FONT_SIZE_SUCCESS, payload: result.data})
    } catch(e) {
        dispatch({type: REQUEST_FONT_SIZE_FAILED, payload: e.message})
    }
}

export const handleColorButtonChange = (color,id) => async(dispatch) => {
    dispatch({
        type:COLOR_BUTTON,
        payload:color
    });
    dispatch({type: REQUEST_COLOR_BUTTON_PENDING});
    try{
        const result = await axios.put(`/customize/colorbtn?q=${id}`,{
            color_button:color
        });
        dispatch({type: REQUEST_COLOR_BUTTON_SUCCESS, payload: result.data})
    } catch(e) {
        dispatch({type: REQUEST_COLOR_BUTTON_FAILED, payload: e.message})
    }
}

export const handleColorBackgroundChange = (color,id) => async(dispatch) => {
    dispatch({
        type:COLOR_BACKGROUND,
        payload:color
    });
    dispatch({type: REQUEST_COLOR_BACKGROUND_PENDING});
    try{
        const result = await axios.put(`/customize/backgroundcolor?q=${id}`,{
            color_background:color
        });
        dispatch({type: REQUEST_COLOR_BACKGROUND_SUCCESS, payload: result.data})
    } catch(e) {
        dispatch({type: REQUEST_COLOR_BACKGROUND_FAILED, payload: e.message})
    }
}

export const getRoom = (user_one,user_two) => async(dispatch) => {
    dispatch({type: REQUEST_ROOM_PENDING});
    try{
        const result = await axios.post("/room",{
            user_one_id:user_one,
            user_two_id:user_two
        });
        dispatch({type: REQUEST_ROOM_SUCCESS, payload: result.data[0]})
    } catch(e) {
        dispatch({type: REQUEST_ROOM_FAILED, payload: e.message})
    }
}

export const getUser = (id) => async(dispatch) => {
    dispatch({type: REQUEST_USER_PENDING});
    try{
        const result = await axios.get(`/user?q=${id}`);
        dispatch({type: REQUEST_USER_SUCCESS, payload: result.data[0]})
    } catch(e) {
        dispatch({type: REQUEST_USER_FAILED, payload: e.message})
    }
}

export const getSecondUser = (id) => async(dispatch) => {
    dispatch({type: REQUEST_SECOND_USER_PENDING});
    try{
        const result = await axios.get(`/user?q=${id}`);
        dispatch({type: REQUEST_SECOND_USER_SUCCESS, payload: result.data[0]})
    } catch(e) {
        dispatch({type: REQUEST_SECOND_USER_FAILED, payload: e.message})
    }
}

export const getRoomMessages = (id) => async(dispatch) => {
    dispatch({type: REQUEST_ROOM_MESSAGES_PENDING});
    try{
        const result = await axios.get(`/roommessages?q=${id}`);
        dispatch({type: REQUEST_ROOM_MESSAGES_SUCCESS, payload: result.data})
    } catch(e) {
        dispatch({type: REQUEST_ROOM_MESSAGES_FAILED, payload: e.message})
    }
}

export const getSectionTitle = (text) => {
    return {
        type:SECTION_TITLE,
        payload:text
    }
}

export const setRoomMessages = () => {
    return {
        type:ROOM_MESSAGES,
        payload:[]
    }
}

export const setSecondUser = () => {
    return {
        type:SECOND_USER,
        payload:[]
    }
}

export const setRoomsSecondUserIdArray = (arr) => {
    return {
        type:ROOMS_SECOND_USER_ID_ARRAY,
        payload:arr
    }
}

export const setDialogTweetShow = (text) => {
    return {
        type:DIALOG_TWEET_SHOW,
        payload:text
    }
}

export const setDialogCustomizeShow = (text) => {
    return {
        type:DIALOG_CUSTOMIZE_SHOW,
        payload:text
    }
}

export const setBackButtonShow = (text) => {
    return {
        type:BACK_BUTTON_SHOW,
        payload:text
    }
}

export const getHomePosts = () => (dispatch) => {
    dispatch({type: REQUEST_HOME_POSTS_PENDING});
    fetch("/posts")
    .then(res => res.json())
    .then(data => {
        dispatch({type: REQUEST_HOME_POSTS_SUCCESS, payload: data})
    })
    .catch(error => dispatch({type: REQUEST_HOME_POSTS_FAILED, payload: error.message}))
}